import React from "react";

const OTPVerification = () => {
  return (
    <div className="container">
      <p>OTP Verification</p>
    </div>
  );
};

export default OTPVerification;